import {
    ExpansionPanel,
    ExpansionPanelContent,
    ExpansionPanelTrigger,
} from '@eventbrite/marmalade';
import React, { useRef } from 'react';
import { LISTING_HEAP_IDS } from '../../../../constants';
import { STATSIG_EVENT_NAMES } from '../../../../experimentation';
import { useTrackComponent } from '../../../hooks/useTrackComponent';
import styles from './Faq.module.scss';
import { FaqWidget } from './types';

interface Props {
    data: FaqWidget;
}

export const Faq: React.FC<Props> = ({ data }) => {
    const ref = useRef(null);

    useTrackComponent({
        ref,
        heap: {
            eventName: LISTING_HEAP_IDS.FAQ_VIEW,
        },
        statsig: {
            eventName: STATSIG_EVENT_NAMES.FAQ_VIEW,
        },
    });
    return (
        <div
            className={styles.wrapper}
            data-testid="Faq"
            data-heap-id={LISTING_HEAP_IDS.FAQS_DROPDOWN}
        >
            <div ref={ref}></div>
            {data.faqs?.map(({ question, answer }) => (
                <ExpansionPanel key={`${question}-${answer}`}>
                    <ExpansionPanelTrigger textClassName={styles.headerContent}>
                        {question}
                    </ExpansionPanelTrigger>
                    <ExpansionPanelContent>
                        <p className={styles.content}>{answer}</p>
                    </ExpansionPanelContent>
                </ExpansionPanel>
            ))}
        </div>
    );
};
